import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import { Button } from '@material-ui/core';
import Http from '../../../Http';
import ACCESS from '../../../ACCESS.js';

class MultipleCancelacion extends TableComponent {

  async componentDidMount() {
    this.tableConfig(
      { dataUrl: 'proceso-cancelacion/filter', deleteUrl: '', deleteField: '', modUrl: '' },
      TableOp.Table('Cancelaciones Multiples', [
        { label: 'Hora Inicio', id: 'start_process' },
        { label: 'Hora Fin', id: 'end_process' },
        { label: 'Usuario', id: 'user' },
        { label: 'Estatus', id: 'status' },
      ], [{
        id: 'reporte', icon: 'picture_as_pdf', tooltip: 'Descargar Reporte', access: [ACCESS.VENTAS_MULTIPLE_CANCELACION.VER_CANCELACIONES]
      }]))
    await this.table();
    let disponible = true;
    if (this.state.tableData.rows.length === 0) {
      disponible = true
    } else {
      disponible = !this.state.tableData.rows.some(dis => dis.status === 'EN PROCESO')
    }
    this.setState({ disponible });
  }

  action = async (id, row) => {
    if (id === 'reporte') {
      this.setState({ loadingReport: true });
      const Resp = await Http.get(`proceso-cancelacion/reporte?id=${row.id}`, true, 'arraybuffer')
      if (!Resp.error) {
        const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
        const a = document.createElement('a');
        const url = URL.createObjectURL(blob)
        a.style.display = 'none';
        a.href = url;
        a.download = `reporte_${row.id}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        this.setState({ loadingReport: false });
      }
    }
  }

  onLiberar = async () => {
    let res = await Http.post(`proceso-cancelacion/liberar`);
  }

  render() {
    const { disponible = true } = this.state;
    const { hasAccess } = this.context;
    return (
      <div>
        {hasAccess(ACCESS.VENTAS_MULTIPLE_CANCELACION.LIBERAR_PROCESO) &&
        <Button onClick={this.onLiberar} >
          Liberar Proceso
        </Button>
        }

        <div style={{ display: 'flex', padding: '0px 10px', justifyContent: 'flex-end', alignItems: 'center' }} >
          {disponible &&
            <Button color="primary" variant={"contained"} onClick={() => { this.props.history.push(`/Ventas/CancelacionFactura`) }} >
              Nueva Cancelacion
            </Button>
          }
        </div>
        <this.TableRender />
      </div>
    )
  }
}

export default withRouter(MultipleCancelacion)